import { combineReducers } from '@reduxjs/toolkit'
import menuReducer from '@widgets/menu/model/slice';
import ContentReducer from "@entities/home_content/model/slice";
import knowledgeReducer from "@entities/knowledge/model/slice";
import modalReducer from "@shared/ui/Modal/model/slice";

export const rootReducer = combineReducers({
    menu: menuReducer,
    content: ContentReducer,
    buildings: knowledgeReducer,
    modal: modalReducer
})